/**
 * Roles a user record can carry, and the NextGen broker roles that map onto `UserRole.Broker`.
 */
export enum UserRole {
  Admin = 'admin',
  Superadmin = 'superadmin',
  User = 'user',
  // PPL roles
  TemplateManager = 'template_manager',
  Broker = 'ppl_broker',
}

// these are all the broker roles in the NextGen platform that map to our single broker role above (Broker)
export const NextGenBrokerRoles = [
  'broker_admin_with_markets',
  'broker_admin_without_markets',
  'historic_upload_broker',
  'monitored_placing_broker',
  'placing_broker',
  'placing_broker_team_lead_and_approver',
] as const;
